import React from "react";
import SectionShell from "./SectionShell";

export default function BenefitsGrid({ heading, items }) {
  const list = Array.isArray(items) ? items : [];
  return (
    <div style={{ justifyContent:"center",display:'flex' }}>
      <SectionShell className="cl-benefits">
        {heading ? <div className="cl-h2">{heading}</div> : null}
        <div className="cl-benefitGrid">
          {list.map((b, i) => (
            <div className="cl-benefit" key={`${b.title}-${i}`}>
              <div className="cl-benefitIcon">{b.icon || "✓"}</div>
              <div className="cl-benefitText">
                <div className="cl-benefitTitle">{b.title}</div>
                {b.body ? (
                  <div className="cl-benefitBody">{b.body}</div>
                ) : null}
              </div>
            </div>
          ))}
        </div>
      </SectionShell>
    </div>
  );
}
